import { QueryClient } from "@tanstack/react-query";

import { ApiRequestError } from "./apiClient";

/**
 * Tekrar denenecek mi — kararı SUNUCU veriyor (`[095]` hata sözleşmesi, `retry.retryable`).
 *
 * ⚠ Ölçülmüş kusur: karşılaştırma ekranı sunucudan 422 + `retryable: false` alıyordu ama
 * istemci bu bilgiyi hiç kullanmıyor, körlemesine yeniden deniyordu. Kullanıcı hata
 * mesajını hiç görmüyor, ekran yükleme iskeletinde kalıyordu — sessiz başarısızlık.
 *
 * ⚠ Kural burada, tek yerde: her ekranın kendi sorgusunda tekrarlansaydı biri unutulur ve
 * aynı sessiz ekran geri gelirdi. `retryable` bilgisi yoksa (ağ kopması, beklenmedik
 * yanıt) eski davranış sürüyor: bir kez daha dene.
 */
export function tekrarDenenirMi(failureCount: number, error: unknown): boolean {
  if (error instanceof ApiRequestError && error.retry?.retryable === false) return false;
  return failureCount < 1;
}

/** Uygulama geneli TanStack Query varsayılanları (plan sözleşmesi: retry 1, staleTime 30 sn). */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: tekrarDenenirMi,
      staleTime: 30_000,
    },
  },
});
